import { compileRoutes } from '@utils/route-compiler.util';
import {
  AdminApprovalRouteNames,
  AdminMembershipRouteNames,
  AdminRouteNames,
  AppRoutesNames,
  AuthenticationRouteNames,
} from '@core/presentation';

// export type AllRouteNames = AppRoutesNames | AuthenticationRouteNames;

export const APP_ROUTES = compileRoutes({
  [AppRoutesNames.authentication]: {
    [AuthenticationRouteNames.basicInfo]: '',
    [AuthenticationRouteNames.changeDefaultPassword]: '',
    [AuthenticationRouteNames.companyInformation]: '',
    [AuthenticationRouteNames.confirmAccount]: '',
    [AuthenticationRouteNames.confirmAccountSingUp]: '',
    [AuthenticationRouteNames.forgotPassword]: '',
    [AuthenticationRouteNames.isBlocked]: '',
    [AuthenticationRouteNames.newPassword]: '',
    [AuthenticationRouteNames.passwordCode]: '',
    [AuthenticationRouteNames.personalInformation]: '',
    [AuthenticationRouteNames.pickPlan]: '',
    [AuthenticationRouteNames.signIn]: '',
    [AuthenticationRouteNames.adminSignUp]: '',
    [AuthenticationRouteNames.adminInfo]: '',
    [AuthenticationRouteNames.employeeInfo]: '',
  },
  [AppRoutesNames.dashboard]: {
    [AdminRouteNames.membership]: {
      [AdminMembershipRouteNames.wallet]: '',
    },
    [AdminRouteNames.approve]: {
      [AdminApprovalRouteNames.details]: '',
    },
    [AdminRouteNames.history]: '',
  },
});

